// Kontekstmeny på kartet (høyreklikk / langtrykk). Flat, rask — ATAKs feil er
// for dype menyer; her maks ett nivå. Byggeren får klikkposisjonen og
// returnerer aktuelle handlinger.
import type { Map as MlMap, LngLat } from 'maplibre-gl';

export interface MenuItem {
  label: string;
  run: () => void;
  danger?: boolean;
}

export class ContextMenu {
  private el: HTMLElement;

  constructor(map: MlMap, build: (lngLat: LngLat) => MenuItem[]) {
    this.el = document.createElement('div');
    this.el.className = 'ctx-menu';
    document.body.append(this.el);

    map.on('contextmenu', (e) => {
      e.preventDefault();
      const items = build(e.lngLat);
      this.show(e.point.x, e.point.y, items);
    });
    document.addEventListener('click', () => this.hide());
    document.addEventListener('keydown', (ev) => {
      if (ev.key === 'Escape') this.hide();
    });
  }

  private show(x: number, y: number, items: MenuItem[]) {
    this.el.innerHTML = '';
    for (const it of items) {
      const row = document.createElement('div');
      row.className = 'ctx-item' + (it.danger ? ' danger' : '');
      row.textContent = it.label;
      row.addEventListener('click', (e) => {
        e.stopPropagation();
        this.hide();
        it.run();
      });
      this.el.append(row);
    }
    this.el.style.left = `${x}px`;
    this.el.style.top = `${y}px`;
    this.el.classList.add('show');
  }

  hide() {
    this.el.classList.remove('show');
  }
}
